// import "./PageHead.scss"; // Removed for version update
import RangeCal from '../DateRange/DateRange';
import { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import Autocomplete from '../../utils/autocomplete';
import { DropDownInput } from '../../utils/reuseAbleInputs';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMerchantList } from '../../../store/actions/merchantList';
import { Tooltip } from 'antd';
import Image from 'next/image';

const PageHead = (props) => {
  const [hidden, setHidden] = useState(true);
  const merchantList = useSelector((state) => state.merchantList);
  const [searchMerchant, setSearchMerchant] = useState('');
  const [TransactionFilterModel, setTransactionFilterModel] = useState({
    filter_type: '',
  });
  const dispatch = useDispatch();
  const changeDate = (start, end) => {
    if (end == null) {
      props.setEndDate(null);
    }
    if (start != null && end != null) {
      // if (end) {
      // alert("hello");
      props.setStartDate(formatDate(start));
      props.setEndDate(formatDate(end));
      setHidden(!hidden);
      // }
    }
  };

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
    // return [day, month, year].join("-");
  }

  const router = useRouter();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setHidden(true);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }
  useEffect(() => {
    !merchantList.length && dispatch(fetchMerchantList());
  }, []);
  useEffect(() => {
    if (searchMerchant == '') makeOrdersApiCall();
    else if (props.resetMerchantInputFlag) props.setResetMerchantInputFlag(false);
  }, [searchMerchant]);
  const makeOrdersApiCall = (merchantId) => {
    props.setMerchantId?.(merchantId);
  };
  useEffect(() => {
    if (props.resetMerchantInputFlag) setSearchMerchant('');
  }, [props.resetMerchantInputFlag]);
  useEffect(() => {
    if (props?.isFilterTypeVisible) {
      props?.setFilterType(TransactionFilterModel.filter_type);
    }
  }, [TransactionFilterModel]);

  function todayDate(d = new Date()) {
    d.setDate(new Date().getDate());
    return [d.getFullYear(), d.getMonth() + 1, d.getDate()].map((n) => (n < 10 ? `0${n}` : `${n}`)).join('-');
  }

  return (
    <div className='row'>
      <div className='col-sm-12 page-header d-flex justify-content-between align-items-center'>
        <div className=''>
        <div className='d-flex margin-l1'>
          <h1 className='fs18 lh-35 metro-m text-d-blue margin-r10'>{props.title}</h1>
          {props.ReportToolTip == true && <Tooltip 
              placement='right'
              color='white'
              overlayClassName='inter fw500 text-black fs11 lh-18'
              overlayInnerStyle={{
                color: '#000000',
              }}
              title={'Visit the Reports section to download your data'}
            >
              <Image src={'/images/info-icon-grey.svg'} height={21} width={21} />
            </Tooltip>}
            </div>
          <p className='fs13 lh-16 metro-l text-l-blue'>{props.description}</p>
        </div>
        <div className={`d-flex ${props?.isFilterTypeVisible ? 'justify-content-end width-100' : ''}`}>
          {(router.pathname === '/' || router.pathname === '/refund') && (
            <div className='merchant-search-box'>
              <Autocomplete
                list={merchantList.map((u) => u.name)}
                value={searchMerchant}
                onChange={(e) => {
                  const currentInput = e.target.value;
                  setSearchMerchant(currentInput);
                  props.setIsMerchantSelected?.(true);
                  props.setData?.([]);
                  const index = merchantList.map((u) => u.name).indexOf(currentInput);
                  if(searchMerchant){
                    props.setIsSearchMerchant?.(true);
                    if (index !== -1) {
                      let merchantID = router.pathname === '/refund' ? merchantList[index].m_id : merchantList[index].id;
                      makeOrdersApiCall(merchantID);
                    }else{
                      props.setFlag?.(false);
                    }
                  }
                  if (currentInput === '') makeOrdersApiCall(null);
                }}
                placeholder='Search Merchant'
              />
              {props.isMerchantSelected === false && (
                <p style={{ color: 'red', fontSize: '12px', paddingTop: '8px', paddingLeft: '5px' }}>
                  {props.title !== 'Stats'
                    ? 'Required field'
                    : props.endDate === formatDate(new Date()) && props.startDate === formatDate(new Date())
                    ? "Select merchant for today's data"
                    : null}
                </p>
              )}
            </div>
          )}
        </div>

        {props?.isFilterTypeVisible && (
          <div className={`col-sm-4 w-full ml-5`}>
            <DropDownInput
              colWidth={10}
              label='Select Filter Type'
              data={TransactionFilterModel}
              dataKey='filter_type'
              setData={setTransactionFilterModel}
              options={['Transactions', 'Settlements']}
            />
          </div>
        )}

        <div className={`date-range-section ${props.onlyDate ? '' : 'col-sm-5'} `}>
          <div className='date-wrapper bora-6'>
            <img className='margin-r15' src='/images/calendar.svg' />
            <span
              onClick={() => setHidden(!hidden)}
              className='day-slot select-box fs-14 lh-14 text-l-blue metro-r margin-r25'
            >
              {props.dateSlot}
            </span>
            <span className='date-range fs-14 lh-14 text-blue metro-r'>
              {props.startDate}
              <span className='text-l-blue'> to </span>
              {props.endDate}
            </span>
          </div>
          {hidden ? null : (
            <div className='slot-list' ref={wrapperRef}>
              <ul>
                <li
                  onClick={() => {
                    props.setDateSlot('Today');
                    props.setStartDate(formatDate(new Date()));
                    props.setEndDate(formatDate(new Date()));
                    setHidden(!hidden);
                  }}
                >
                  Today
                </li>
                <li
                  onClick={() => {
                    props.setDateSlot('Yesterday');
                    props.setStartDate(formatDate(new Date(new Date().setDate(new Date().getDate() - 1))));
                    props.setEndDate(formatDate(new Date(new Date().setDate(new Date().getDate() - 1))));
                    setHidden(!hidden);
                  }}
                >
                  Yesterday
                </li>
                <li
                  onClick={() => {
                    props.setDateSlot('Last 7 days');
                    props.setStartDate(formatDate(new Date(new Date().setDate(new Date().getDate() - 6))));
                    props.setEndDate(formatDate(new Date()));
                    setHidden(!hidden);
                  }}
                >
                  Last 7 days
                </li>
                <li
                  onClick={() => {
                    props.setDateSlot('Last 30 days');
                    props.setStartDate(formatDate(new Date(new Date().setDate(new Date().getDate() - 29))));
                    props.setEndDate(formatDate(new Date()));
                    setHidden(!hidden);
                  }}
                >
                  Last 30 days
                </li>
                <li onClick={() => props.setDateSlot('Custom Date')} className='custom-date date-picker-input'>
                  Custom Date{' '}
                  <RangeCal
                    changeDate={changeDate}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    disabledAfterDate={todayDate()}
                  />
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHead;
